// extracted by mini-css-extract-plugin
export var actionIcon = "_oi-0";